/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { sqrtDependencies } from './dependenciesSqrt.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { varianceDependencies } from './dependenciesVariance.generated';
import { createStdTransform } from '../../factoriesAny.js';
export var stdTransformDependencies = {
  sqrtDependencies: sqrtDependencies,
  typedDependencies: typedDependencies,
  varianceDependencies: varianceDependencies,
  createStdTransform: createStdTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesStdTransform.generated.js
// module id = 1662
// module chunks = 0